import theme from "@/muiTheme";
import { categories, SkillName } from "../UserAndProfile/UserContext";

// Reusable type definitions for test results display

/**
 * Represents the performance metrics for a specific skill.
 */
export type SkillPerformance = {
  skill: string;
  section: "Math" | "Reading and Writing";
  percentCorrect: number;
  avgTime: number; // Average time in seconds
  targetTime: number; // Target time in seconds
  questionsAttempted: number;
};

/**
 * Represents the data needed to display a summary of a missed question.
 * Note: The source of 'questionIndex' might differ between test types.
 */
export type MissedQuestionDisplayData = {
  sectionIndex?: number; // Index of the section in the test - only on Full Length Tests
  questionIndex: number; // Original index in its source list/section
  skill: SkillName;
  difficulty: 'Easy' | 'Medium' | 'Hard';
  section: "Math" | "Reading and Writing";
  timeSpent: string; // Formatted time string (e.g., "1m 30s")
  questionPreview: string; // Truncated or full question text/description
  explanation: string; // Explanation for the correct answer
  //strategy?: string; // Optional strategy relevant to the skill/question
};

export type FullTestMissedQuestionDisplayData = {
    sectionIndex: number; // Index of the section in the test - only on Full Length Tests
    questionIndex: number; // Original index in its source list/section
    skill: SkillName;
    difficulty: 'Easy' | 'Medium' | 'Hard';
    section: "Math" | "Reading and Writing";
    timeSpent: string; // Formatted time string (e.g., "1m 30s")
    questionPreview: string; // Truncated or full question text/description
    explanation: string; // Explanation for the correct answer
    //strategy?: string; // Optional strategy relevant to the skill/question
  };


export function getSkillSection(skill: string): "Math" | "Reading and Writing" {
  // Explicitly check against the readonly array from categories
  if ((categories.Math as readonly string[]).includes(skill)) {
    return "Math";
  }
  // Assume Reading and Writing if not Math
  return "Reading and Writing";
}